<div class="menu-item">
  <div class="menu-header">
    {{item.menutitle}}
    <!-- <button class="add-child-btn" (click)="addChild()">+ ქვე მენიუ</button> -->
    <button class="btn btn-sm btn-primary" (click)="openEditModal()">
      <i class="fi fi-rr-edit"></i>
    </button>
    <button class="btn " *ngIf="item.children?.length" (click)="showChildren = !showChildren">
      <i class="fi fi-rr-add d-flex align-items-center" *ngIf="!showChildren"></i>
      <i class="fi fi-rr-minus-circle d-flex align-items-center" *ngIf="showChildren"></i>
    </button>
  </div>

  <div
    class="children"
    *ngIf="showChildren"
    cdkDropList
    [cdkDropListData]="item.children"
    (cdkDropListDropped)="dropChild($event)"
  >
    <div
      class="submenu"
      *ngFor="let child of item.children"
      cdkDrag
    >
      <app-menu-item
        [item]="child"
        (update)="update.emit()"
      ></app-menu-item>
    </div>
  </div>
</div>